import type { Cart } from "@shopify/hydrogen-react/storefront-api-types";

type TCartState = Cart;

const initialStateCart: TCartState = {
  attributes: [],
  deliveryGroups: {
    edges: [],
    nodes: [],
    pageInfo: {
      hasNextPage: false,
      hasPreviousPage: false,
    },
  },
  estimatedCost: {
    checkoutChargeAmount: {
      amount: "",
      currencyCode: "KRW",
    },
    subtotalAmount: {
      amount: "",
      currencyCode: "KRW",
    },
    totalAmount: {
      amount: "",
      currencyCode: "KRW",
    },
  },
  checkoutUrl: "",
  createdAt: "",
  metafields: [],
  updatedAt: "",
  buyerIdentity: {
    deliveryAddressPreferences: [],
    walletPreferences: [],
  },
  cost: {
    checkoutChargeAmount: {
      amount: "",
      currencyCode: "KRW",
    },
    subtotalAmount: {
      amount: "",
      currencyCode: "KRW",
    },
    totalAmount: {
      amount: "",
      currencyCode: "KRW",
    },
    __typename: "CartCost",
    subtotalAmountEstimated: false,
    totalAmountEstimated: false,
    totalDutyAmountEstimated: false,
    totalTaxAmountEstimated: false,
  },
  discountAllocations: [],
  discountCodes: [],
  id: "",
  lines: {
    edges: [],
    nodes: [],
    pageInfo: {
      endCursor: undefined,
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: undefined,
    },
  },
  totalQuantity: 0,
};

const CART_UPDATE_CART = "CART/UPDATE_CART" as const;

export const cart = (
  state: TCartState = initialStateCart,
  action: TCartAction,
) => {
  switch (action.type) {
    case CART_UPDATE_CART:
      return {
        ...action.cart,
      };
    default:
      return state;
  }
};

type TCartAction = ReturnType<typeof updateCart>;

export const updateCart = (_cart: Cart) => ({
  type: CART_UPDATE_CART,
  cart: _cart,
});

export const cartCreator = {
  updateCart,
};
